var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGithubinline = function SvgGithubinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#141A1F",
    fillRule: "evenodd",
    d: "M14.065 1.118A13.21 13.21 0 0 0 1.012 12.21 13.2 13.2 0 0 0 9.89 26.857c.665.121.9-.292.9-.64V23.97c-3.69.802-4.468-1.776-4.468-1.776a3.53 3.53 0 0 0-1.468-1.937c-1.192-.81.097-.81.097-.81a2.78 2.78 0 0 1 2.02 1.361 2.82 2.82 0 0 0 3.843 1.103c.051-.667.339-1.294.811-1.767-2.935-.333-6.017-1.468-6.017-6.486a5.1 5.1 0 0 1 1.354-3.542 4.81 4.81 0 0 1 .13-3.494s1.111-.357 3.633 1.354a12.5 12.5 0 0 1 6.617 0c2.522-1.71 3.625-1.354 3.625-1.354a4.8 4.8 0 0 1 .162 3.47 5.1 5.1 0 0 1 1.354 3.542c0 5.075-3.09 6.185-6.033 6.485a3.12 3.12 0 0 1 .9 2.432v3.624c0 .43.235.762.908.632a13.21 13.21 0 0 0 8.732-14.61 13.205 13.205 0 0 0-12.924-11.08",
    clipRule: "evenodd"
  })));
};
export default SvgGithubinline;